import { render, staticRenderFns } from "./SystemSettingsSmtp.vue?vue&type=template&id=4a419708&scoped=true"
import script from "./SystemSettingsSmtp.vue?vue&type=script&lang=js"
export * from "./SystemSettingsSmtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a419708",
  null
  
)

export default component.exports